import React, { Component } from 'react';
import {
  arrayOf, bool, func, shape, string
} from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import Helper from '../../Helper';
import './thumbnails.style.scss';
import '../../media-gallery.style.scss';

export default class Thumbnails extends Component {

  render() {

    const { onThumbnailClick, thumbnails } = this.props;

    return (
      <>
        {thumbnails.map((thumb, thumbIndex) => {
          const isVideo = Helper.isVideo({ media: thumb });
          const isThreesixty = Helper.isImage360({ media: thumb });
          const isAR = Helper.isAR({ media: thumb });
          const isAltMedia = isVideo || isThreesixty || isAR;
          let thumbnailUrl = thumb.url;
          if (isVideo) {
            thumbnailUrl = thumb.videoStill;
          } else if (isThreesixty || isAR) {
            thumbnailUrl = thumb.mediaStill;
          }
          const thumbnailStyle = classNames(
            'thumbnail__image-block',
            { 'thumbnail__image-block--selected': thumb.isSelected }
          );
          if (isAltMedia) {
            return (
              <div key={thumbIndex} className="thumbnail__wrapper">
                <button
                  type="button"
                  className={thumbnailStyle}
                  onClick={() => onThumbnailClick(thumb)}
                >
                  <Image
                    alt=""
                    className="thumbnail__image"
                    src={thumbnailUrl}
                    lazy
                  />
                  {Helper.isAR({ media: thumb }) && (
                    <>
                      <span className="background-circle background-circle--thumbnail" />
                      <span className="ar-icon ar-icon--thumbnail" />
                    </>
                  )}
                  {isVideo && (
                    <>
                      <span className="background-circle background-circle--thumbnail" />
                      <span className="play-icon play-icon--thumbnail" />
                    </>
                  )}
                  {isThreesixty && (
                    <>
                      <span className="background-circle background-circle--thumbnail" />
                      <span className="threesixty-icon threesixty-icon--thumbnail" />
                    </>
                  )}
                </button>
              </div>
            );
          } if (Helper.isImage({ media: thumb })) {
            return (
              <div key={thumbIndex} className="thumbnail__wrapper">
                <button
                  type="button"
                  className={thumbnailStyle}
                  onClick={() => onThumbnailClick(thumb)}
                >
                  <Image
                    className="thumbnail__image"
                    src={thumb.url}
                    alt=""
                    lazy
                  />
                </button>
              </div>
            );
          }
          return null;
        })}
      </>
    );
  }
}

Thumbnails.propTypes = {
  onThumbnailClick: func.isRequired,
  thumbnails: arrayOf(shape({
    brandName: string,
    productLabel: string,
    imageUrl: string,
    isSelected: bool
  }))
};

Thumbnails.defaultProps = {
  thumbnails: []
};
